import React, { Component } from 'react';
import DataTable from "react-data-table-component";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { tokenVerification, textDirection } from './Utils';
import { Multiselect } from 'multiselect-react-dropdown';

class JournalReminder extends Component {
    constructor() {
        super();
        this.state = {
            disabled: false,
            dataStartedProcessing: false,
            savingData: false,
            // data: [{
            //     id: '',
            //     journalId: '',
            //     daysOfWeek: '',
            //     timeOfDay: '',
            //     title: '',
            //     content: '',
            //     remIntervalMinutes: ''
            // }
            // ],
            data: [],
            editedId: "-1",
            pageNum: null,
            paginationValue: 10,
            hidden: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            options: [],
            selectedDaysName: [],
            selectedDays: [],
            reminderTime: "",
            editedDaysOfWeek: [],
            editedReminderTime: "",
            showModal: false,
            daysChanged: false,
            hideNotifyBtn: false,
            notificationData: {},
            hideSaveBtn: false,
            showDropdown: true,
            notificationPresent: false,
            isLoading: true,
            noMatchingData: false,
            searchTerm: "",
            showTranslationModal: false,
            selectedReminderId: null,
            selectedLanguage: "es",
            translationLanguages: [],
            translationFields: {
                title: "",
                content: ""
            },
            autoTranslating: false,
            translationLoading: false,

        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
        this.userDetails = JSON.parse(localStorage.getItem("user_details"));
    }
    componentDidMount() {
        this.fetchDaysOfWeek();
        this.fetchJournalReminder();
    }
    goBackFromSubTab = () => {
        var pageNum = this.props.location.state.pageNum;
        this.props.history.push({
            pathname: "/projectmgmt/journal",
            state: {
                // goBackToFaq: true,
                pageNum: pageNum,
                journalId: this.props.location.state.journalId,
            }
        });
    }
    refreshData = (id) => {
        console.log("Resetting the data");
        this.state.data = [];
        this.state.isLoading = true;
        this.state.searchTerm = "";
        this.state.noMatchingData = false;
        this.state.editedId = "-1";
        this.state.disabled = false;
        this.state.hideNotifyBtn = false;
        this.setState(this.state);
        this.fetchJournalReminder();
    }

    fetchDaysOfWeek = () => {
        var thisController = this;

        $.ajax({
            url: "/my-jeeva-api/load-daysOfWeek",

            method: 'GET',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.success === true) {
                    var days = res.result;
                    var formattedDays = days.map(day => ({
                        label: day.slice(0, 3).charAt(0).toUpperCase() + day.slice(0, 3).slice(1).toLowerCase(),// Assuming you want the label in lowercase
                        value: day.slice(0, 3).toUpperCase()
                    }));
                    thisController.state.disabled = false;
                    thisController.state.showLoader = true;
                    thisController.state.options = formattedDays;
                    thisController.setState(thisController.state);
                } else {
                    thisController.notifyError(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    tokenVerification();
                }
            }
        });
    }

    fetchJournalReminder = () => {
        var thisController = this;

        $.ajax({
            url: "/my-jeeva-api/all-journal-Reminders",

            method: 'GET',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                journalId: this.props.location.state.journalId,
            },
            success: function (res) {
                if (res.success === true) {
                    var reminders = res.result;
                    thisController.state.disabled = false;
                    thisController.state.isLoading = false;
                    thisController.state.noMatchingData = false;
                    thisController.state.showLoader = true;
                    thisController.state.data = reminders;
                    thisController.setState(thisController.state);

                    // Fetch journal to get group ID for language filtering
                    thisController.fetchJournalDetails();
                } else {
                    // thisController.notifyError(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    tokenVerification();
                }
            }
        });
    }

    fetchJournalDetails = () => {
        var thisController = this;
        $.ajax({
            url: "/my-jeeva-api/fetch-journal-with-id",
            method: 'GET',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                id: this.props.location.state.journalId
            },
            success: function (res) {
                if (res.success === true && res.result) {
                    var journalGroupId = res.result.journalGroupId;
                    thisController.state.journalGroupId = journalGroupId;
                    thisController.setState(thisController.state);
                    // Fetch only enabled languages for this journal group
                    thisController.fetchTranslationLanguages(journalGroupId);
                }
            },
            error: function (xhr) {
                console.error("Error fetching journal details");
                // Fallback to all languages if journal fetch fails
                thisController.fetchTranslationLanguages(null);
            }
        });
    }
    saveJournalReminderApi = (props, e) => {

        var thisController = this;
        if (thisController.state.selectedDaysName.length === 0) {
            var daysOfWeekValue = props.daysOfWeek.map((item) => item.value);
            var title = document.getElementById("title" + props.id).innerText.trim();
            var content = document.getElementById("content" + props.id).innerText.trim();;
            var remIntervalMinutes = document.getElementById("remIntervalMinutes" + props.id).innerText.trim();
            if (thisController.state.reminderTime === "" || daysOfWeekValue.length === 0 || title === "" ||
                content === "" || remIntervalMinutes === "") {
                thisController.notifyMsgFieldEmpty();
            } else {
                var saveData = {
                    journalId: thisController.props.location.state.journalId,
                    journalTitle: localStorage.getItem("journalTitle"),
                    daysOfWeek: JSON.stringify(daysOfWeekValue),
                    timeOfDay: thisController.state.reminderTime,
                    title: title,
                    content: content,
                    remIntervalMinutes: remIntervalMinutes,
                }
                $.ajax({
                    url: "/my-jeeva-api/save-journal-Reminder",
                    method: 'POST',
                    data: JSON.stringify(saveData),
                    headers: {
                        'Authorization': "Bearer " + localStorage.getItem("access_token"),
                        'Content-Type': "application/json",

                    },
                    success: function (res) {
                        if (res.success === true) {
                            thisController.notifyAdded();
                            thisController.state.disabled = false;
                            thisController.state.hideNotifyBtn = false;
                            thisController.setState(thisController.state);
                            thisController.fetchJournalReminder();
                        } else {
                            // thisController.notifyError();
                            thisController.state.disabled = false;
                        }
                        thisController.setState({ savingData: false });
                    },
                    error: function (xhr, status, error) {
                        if (xhr.status == 401) {
                            tokenVerification();
                        }
                    }
                })
            }

        } else {
            var title = document.getElementById("title" + props.id).innerText.trim();
            var content = document.getElementById("content" + props.id).innerText.trim();
            var remIntervalMinutes = document.getElementById("remIntervalMinutes" + props.id).innerText.trim();
            if (thisController.state.selectedDaysName.length === 0 || thisController.state.reminderTime === ""
                || title === "" || content === "" || remIntervalMinutes === "") {
                thisController.notifyMsgFieldEmpty();
            } else {
                var daysOfWeekValue = thisController.state.selectedDaysName.map((item) => item.value)
                var customOrder = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
                var sortedDays = [];
                for (var index = 0; index < customOrder.length; index++) {
                    var day = customOrder[index];
                    for (var zindex = 0; zindex < daysOfWeekValue.length; zindex++) {
                        if (daysOfWeekValue[zindex] === day) {
                            sortedDays.push(day)
                        }
                    }
                }
                console.log("sortedDays", sortedDays);
                var saveData = {
                    journalId: thisController.props.location.state.journalId,
                    journalTitle: localStorage.getItem("journalTitle"),
                    daysOfWeek: JSON.stringify(sortedDays),
                    timeOfDay: thisController.state.reminderTime,
                    title: title,
                    content: content,
                    remIntervalMinutes: remIntervalMinutes
                }
                $.ajax({
                    url: "/my-jeeva-api/save-journal-Reminder",
                    method: 'POST',
                    data: JSON.stringify(saveData),
                    headers: {
                        'Authorization': "Bearer " + localStorage.getItem("access_token"),
                        'Content-Type': "application/json",

                    },
                    success: function (res) {
                        if (res.success === true) {
                            thisController.notifyAdded();
                            thisController.state.disabled = false;
                            thisController.state.hideNotifyBtn = false;
                            thisController.setState(thisController.state);
                            thisController.fetchJournalReminder();
                        } else {
                            // thisController.notifyError();
                            thisController.state.disabled = false;
                        }
                        thisController.setState({ savingData: false });
                    },
                    error: function (xhr, status, error) {
                        if (xhr.status == 401) {
                            tokenVerification();
                        }
                    }
                })
            }
        }

    }


    CustomNoDataComponent = () => (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <p>There are no journal notifications set.</p>
        </div>
    );

    updateJournalReminderApi(props, e) {
        var thisController = this;
        var daysOfWeekValue = [];
        var sortedDaysofWeek = [];
        if (thisController.state.daysChanged) {
            var daysOfWeekValue = this.state.selectedDaysName.map((item) => item.value);
            daysOfWeekValue = JSON.stringify(daysOfWeekValue);

            if (daysOfWeekValue.includes("SAT")) {
                sortedDaysofWeek.unshift("SAT")
            }
            if (daysOfWeekValue.includes("FRI")) {
                sortedDaysofWeek.unshift("FRI")
            }
            if (daysOfWeekValue.includes("THU")) {
                sortedDaysofWeek.unshift("THU")
            }
            if (daysOfWeekValue.includes("WED")) {
                sortedDaysofWeek.unshift("WED")
            }
            if (daysOfWeekValue.includes("TUE")) {
                sortedDaysofWeek.unshift("TUE")
            }
            if (daysOfWeekValue.includes("MON")) {
                sortedDaysofWeek.unshift("MON")
            }
            if (daysOfWeekValue.includes("SUN")) {
                sortedDaysofWeek.unshift("SUN")
            }
            console.log("Sorted According to order : ", sortedDaysofWeek);

            sortedDaysofWeek = JSON.stringify(sortedDaysofWeek);

        } else {
            sortedDaysofWeek = props.daysOfWeek
        }
        var updateData = {
            id: props.id,
            journalId: thisController.props.location.state.journalId,
            daysOfWeek: sortedDaysofWeek,
            timeOfDay: document.getElementById("reminderTime" + props.id).value,
            title: document.getElementById("title" + props.id).innerText.trim(),
            content: document.getElementById("content" + props.id).innerText.trim(),
            remIntervalMinutes: document.getElementById("remIntervalMinutes" + props.id).innerText.trim()
        }
        $.ajax({
            url: "/my-jeeva-api/update-journal-Reminder",

            method: 'PATCH',
            data: JSON.stringify(updateData),
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
                'Content-Type': "application/json"
            },
            success: function (res) {
                if (res.success == true) {
                    thisController.state.editedId = "-1";
                    thisController.notifyUpdated();
                    thisController.state.disabled = false;
                    thisController.state.hideNotifyBtn = false;
                    thisController.state.daysChanged = false;
                    thisController.setState(thisController.state);
                    thisController.fetchJournalReminder();
                } else {
                    // thisController.notifyError();
                    thisController.state.disabled = false;
                    thisController.setState(thisController.state);
                }
            },
            error: function (xhr, status, error) {
                if (xhr.status == 401) {
                    tokenVerification();
                }
            }
        })

    }

    addNewReminder = () => {
        var thisController = this;
        thisController.state.paginationValue = thisController.state.paginationValue + 5;
        if (thisController.state.pageNum != 0) {
            thisController.setState({ pageNum: 0 })
        }
        this.state.data.unshift({
            id: '',
            journalId: '',
            daysOfWeek: this.state.options,
            timeOfDay: '',
            title: '',
            content: '',
            remIntervalMinutes: ''
        });
        this.setState({
            data: this.state.data,
            disabled: true,
            hideNotifyBtn: true,
            selectedDaysName: [],
            reminderTime: ""
        })
    }
    makeCelleditable(props, e) {
        this.markAsBeingEdited(props.id);
        this.state.editedDaysOfWeek = props.daysOfWeek;
        this.state.editedReminderTime = props.reminderTime;
        this.state.disabled = true;
        this.state.hideNotifyBtn = true;
        this.setState(this.state);

    }

    markAsBeingEdited(id) {
        this.state.editedId = id;
        var stateObj = this.state;
        this.setState(stateObj);
    }

    openDeletePopUp = (props) => {

        confirmAlert({
            title: 'Confirm to Delete',
            message: `Are you sure you want to delete ${props.title} ?`,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.deleteJournalReminderApi(props)
                },
                {
                    label: 'No',
                }
            ]
        });
    }

    deleteJournalReminderApi = (props) => {
        let deleteRowViewController = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;
        var id = props.id;

        if (props.id == "") {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
            deleteRowViewController.splice(props.id, 1);
        } else {
            $.ajax({
                url: "/my-jeeva-api/delete-journal-Reminder/" + id,

                method: 'DELETE',
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("access_token")
                },
                success: function (res) {

                    if (res.success === true) {

                        deleteApiViewController.setState({ deleteRow: true });
                        deleteConstructorVariables.setState({ hideDeletePopup: false });
                        deleteRowViewController.splice(props.id, 1);
                        deleteConstructorVariables.notifyDelete();
                        deleteConstructorVariables.refreshData();

                    } else {
                        // deleteConstructorVariables.notifyError();
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        tokenVerification();
                    }
                }
            });
        }
    }
    saveJournalNotificationApi = (props, e) => {

        var thisController = this;
        var content = document.getElementById("notificationContent").value.trim();
        var title = document.getElementById("notificationTitle").value.trim();
        var remIntervalMinutes = document.getElementById("notificationRemindTime").value.trim();
        if (content === "" || title === "" || remIntervalMinutes === "") {
            thisController.notifyMsgFieldEmpty()
        } else {
            var saveData = {
                content: content,
                title: title,
                remIntervalMinutes: remIntervalMinutes,
                sourceId: thisController.state.sourceId,
                sourceType: "JOURNAL_SCHEDULE",
            }

            $.ajax({
                url: "/my-jeeva-api/save-notification-info",

                method: 'POST',
                data: JSON.stringify(saveData),
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': "application/json",

                },
                success: function (res) {
                    if (res.success === true) {

                        thisController.notifyNotificationAdded();
                        thisController.state.disabled = false;
                        thisController.setState(thisController.state);
                        thisController.fetchJournalReminder();
                        thisController.setState({ showModal: false });
                    } else {
                        // thisController.notifyError();
                        thisController.state.disabled = false;
                    }
                    thisController.setState({ savingData: false });
                },
                error: function (xhr, status, error) {
                    if (xhr.status == 401) {
                        tokenVerification();
                    }
                }
            })
        }
    }

    updateJournalNotificationApi = () => {
        var thisController = this;
        var content = document.getElementById("updateContent").value.trim();
        var title = document.getElementById("updateTitle").value.trim();
        var remIntervalMinutes = document.getElementById("updateTime").value.trim();
        if (content === "" || title === "" || remIntervalMinutes === "") {
            thisController.notifyMsgFieldEmpty()
        } else {
            var saveData = {
                content: content,
                title: title,
                remIntervalMinutes: remIntervalMinutes,
                sourceId: thisController.state.sourceId,
                sourceType: "JOURNAL_SCHEDULE",
            }
            $.ajax({
                url: "/my-jeeva-api/update-notification-info",
                method: 'POST',
                data: JSON.stringify(saveData),
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': "application/json",

                },
                success: function (res) {
                    if (res.success === true) {

                        thisController.notifyNotificationUpdted();
                        thisController.state.disabled = false;
                        thisController.setState(thisController.state);
                        thisController.fetchJournalReminder();
                        thisController.setState({ showModal: false });
                    } else {
                        // thisController.notifyError();
                        thisController.state.disabled = false;
                    }
                    thisController.setState({ savingData: false });
                },
                error: function (xhr, status, error) {
                    if (xhr.status == 401) {
                        tokenVerification();
                    }
                }
            })
        }
    }

    fetchJournalNotificationInfo = (row) => {
        var thisController = this;

        $.ajax({
            url: "/my-jeeva-api/get-notification-info",

            method: 'GET',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                sourceId: row.id,
            },
            success: function (res) {
                if (res.success === true) {
                    var notifications = res.result;
                    thisController.state.disabled = false;
                    thisController.state.notificationPresent = true;
                    thisController.state.showLoader = true;
                    thisController.state.hideSaveBtn = true;
                    thisController.state.notificationData = notifications;
                    thisController.setState(thisController.state);
                }
                else {
                    thisController.setState({
                        notificationData: {
                            title: "",
                            content: "",
                            remIntervalMinutes: ""
                        },
                    })
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    tokenVerification();
                }
            }
        });
    }

    handleChangeTime = (row, e) => {
        this.state.reminderTime = e.target.value;
        if (row.timeOfDay !== "") {
            row.timeOfDay = e.target.value;
        }
        this.setState(this.state);
    };



    handleDaysSelect = (selectedList, selectedItem, row) => {
        var thisController = this;
        thisController.state.selectedDaysName = selectedList;
        thisController.state.daysChanged = true;
        thisController.setState(thisController.state);
    };
    handleDaysRemove = (selectedList, selectedItem) => {
        var thisController = this;
        thisController.state.selectedDaysName = selectedList;
        thisController.state.daysChanged = true;
        thisController.setState(thisController.state);
    };

    showNotifyModal = (row, e) => {
        this.state.sourceId = row.id
        this.state.showModal = true;
        this.state.notificationPresent = false
        this.state.notificationData = {}
        this.state.hideSaveBtn = false;
        this.setState(this.state);
        this.fetchJournalNotificationInfo(row);
    }
    handleTitleChange = (e) => {
        this.setState({
            notificationData: {
                title: e.target.value
            }
        });
    }
    handleContentChange = (e) => {
        this.setState({
            notificationData: {
                content: e.target.value
            }
        });
    };

    handleChangeRemInterval = (e) => {
        this.setState({
            notificationData: {
                remIntervalMinutes: e.target.value
            }
        });
    }
    notifyAdded() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Notification has been added successfully</b>, {
            position: "top-center",

        });

    };

    notifyNotificationAdded() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Notification has been saved successfully</b>, {
            position: "top-center",

        });
    }
    notifyNotificationUpdted() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Notification has been updated successfully</b>, {
            position: "top-center",

        });
    }
    notifyUpdated() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp; Notification has been updated successfully</b>, {
            position: "top-center",

        });
    }

    notifyImproperName() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid name</b>, {
            position: "top-center"
        });
    }

    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        });

    }

    notifyError() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
            position: "top-center"
        });
    }

    notifyReminderCloned() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Notification copied successfully.</b>, {
            position: "top-center"
        });
    }

    notifyDelete() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp; Notification deleted successfully</b>, {
            position: "top-center",
        });
    }

    handleClonedData = (row) => {
        this.cloneReminder(row);
        this.state.editableModeOn = true;
        this.setState(this.state);
    };

    cloneReminder = (row) => {
        var thisController = this;

        var saveData = {
            journalId: row.journalId,
            daysOfWeek: row.daysOfWeek,
            timeOfDay: row.timeOfDay,
            journalTitle: row.journalTitle,
            id: row.id,
            title: row.title,
            content: row.content,
            remIntervalMinutes: row.remIntervalMinutes
        };
        $.ajax({
            url: "/my-jeeva-api/clone-reminder",
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
                "Content-Type": "application/json",
            },
            data: JSON.stringify(saveData),

            success: function (res) {
                if (res.success === true) {
                    thisController.setState(thisController.state);
                    thisController.notifyReminderCloned();
                    thisController.fetchJournalReminder();
                    thisController.state.disabled = false;
                    thisController.setState(thisController.state);
                } else {
                    thisController.state.disabled = false;
                    thisController.setState(thisController.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "";
                }
            },
        });
    }

    updateNotification = () => {
        this.state.notificationPresent = false;
        this.setState(this.state);
    }



    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }

    caseInsensitiveSort = (field) => (rowA, rowB) => {

        var a;
        var b;
        if (field === "remIntervalMinutes") {
            a = rowA[field] ? rowA[field] : "";
            b = rowB[field] ? rowB[field] : "";
        } else {
            a = rowA[field] ? rowA[field].toLowerCase() : '';
            b = rowB[field] ? rowB[field].toLowerCase() : '';
        }

        if (a > b) {
            return 1;
        }
        if (b > a) {
            return -1;
        }
        return 0;
    };

    handleSearch = (event) => {
        var thisController = this;
        var searchTerm = event.target.value;
        thisController.state.searchTerm = searchTerm;
        thisController.state.isLoading = true;
        thisController.state.data = [];
        thisController.setState(thisController.state);

        if (!thisController.state.searchTerm || thisController.state.searchTerm.trim() === "") {
            thisController.setState({
                searchTerm: "",
            });
            thisController.fetchJournalReminder();
        }
        else {
            $.ajax({
                url: "/my-jeeva-api/search-journal-reminder-data",
                method: "GET",
                data: {
                    journalId: this.props.location.state.journalId,
                    searchTerm: searchTerm
                },
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                },

                success: function (res) {
                    if (res.success === true) {
                        if (res.result.length > 0) {
                            thisController.state.data = [];
                            thisController.setState(thisController.state);
                            thisController.state.data = res.result;
                            thisController.state.isLoading = false;
                            thisController.state.noMatchingData = false;
                            thisController.setState(thisController.state);
                        } else {
                            thisController.state.noMatchingData = true;
                            thisController.state.isLoading = false;
                            thisController.setState(thisController.state);
                        }
                    }
                },
                error: function (xhr) {

                },
            });
        }

    };

    fetchTranslationLanguages = (procedureId) => {
        var thisController = this;
        var url = procedureId
            ? `/my-jeeva-api/procedure/${procedureId}/languages/enabled`
            : "/my-jeeva-api/translation-edit/languages";

        $.ajax({
            url: url,
            method: "GET",
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true && Array.isArray(res.result)) {
                    // Filter out English and map to displayName format
                    var languages = res.result
                        .filter(lang => lang.code && lang.code.toLowerCase() !== 'en')
                        .map(lang => ({
                            code: lang.code.toLowerCase(),
                            displayName: (lang.englishName || lang.displayName) + '(' + (lang.name || lang.englishName) + ')'
                        }));
                    thisController.setState({ translationLanguages: languages });
                } else if (Array.isArray(res)) {
                    // Handle direct array response
                    var languages = res
                        .filter(lang => lang.code && lang.code.toLowerCase() !== 'en')
                        .map(lang => ({
                            code: lang.code.toLowerCase(),
                            displayName: lang.name || lang.displayName || lang.englishName
                        }));
                    thisController.setState({ translationLanguages: languages });
                }
            },
            error: function (xhr) {
                console.error("Error fetching languages");
            }
        });
    };

    openTranslationModal = (reminder) => {
        this.state.selectedReminderId = reminder.id;
        this.state.showTranslationModal = true;
        this.state.selectedLanguage = "es";
        this.setState(this.state);
        // If languages haven't been loaded yet, fetch them now
        if (!this.state.translationLanguages || this.state.translationLanguages.length === 0) {
            if (this.state.journalGroupId) {
                this.fetchTranslationLanguages(this.state.journalGroupId);
            }
        }
        this.fetchTranslation(reminder.id, "es");
    };

    closeTranslationModal = () => {
        this.state.showTranslationModal = false;
        this.state.selectedReminderId = null;
        this.state.translationFields = { title: "", content: "" };
        this.setState(this.state);
    };

    fetchTranslation = (reminderId, language) => {
        var thisController = this;
        thisController.state.translationLoading = true;
        thisController.setState(thisController.state);

        $.ajax({
            url: "/my-jeeva-api/translation-edit/journalreminder/" + reminderId,
            method: "GET",
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                language: language
            },
            success: function (res) {
                if (res.success === true) {
                    var fields = res.result.fields || { title: "", content: "" };
                    thisController.state.translationFields = fields;
                    thisController.state.translationLoading = false;
                    thisController.setState(thisController.state);

                    // Auto-translate if fields are empty
                    if (!fields.title && !fields.content) {
                        thisController.autoTranslateReminder(reminderId, language);
                    }
                }
            },
            error: function (xhr) {
                thisController.state.translationLoading = false;
                thisController.setState(thisController.state);
                console.error("Error fetching translation");
            }
        });
    };

    autoTranslateReminder = (reminderId, language) => {
        var thisController = this;
        var reminder = thisController.state.data.find(r => r.id === reminderId);
        if (!reminder) return;

        thisController.state.autoTranslating = true;
        thisController.setState(thisController.state);

        // Auto-translate title
        if (reminder.title) {
            $.ajax({
                url: "/my-jeeva-api/translation-edit/auto-translate?language=" + language + "&sourceText=" + encodeURIComponent(reminder.title),
                method: "POST",
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': "application/json",
                },
                success: function (res) {
                    if (res.success === true) {
                        thisController.state.translationFields.title = res.result.translatedText;
                        thisController.setState(thisController.state);
                    }
                },
                error: function (xhr) {
                    console.error("Error auto-translating title");
                }
            });
        }

        // Auto-translate content
        if (reminder.content) {
            $.ajax({
                url: "/my-jeeva-api/translation-edit/auto-translate?language=" + language + "&sourceText=" + encodeURIComponent(reminder.content),
                method: "POST",
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': "application/json",
                },
                success: function (res) {
                    if (res.success === true) {
                        thisController.state.translationFields.content = res.result.translatedText;
                        thisController.state.autoTranslating = false;
                        thisController.setState(thisController.state);
                    }
                },
                error: function (xhr) {
                    thisController.state.autoTranslating = false;
                    thisController.setState(thisController.state);
                    console.error("Error auto-translating content");
                }
            });
        }
    };

    handleTranslationFieldChange = (fieldName, value) => {
        this.state.translationFields[fieldName] = value;
        this.setState(this.state);
    };

    handleLanguageChange = (e) => {
        this.state.selectedLanguage = e.target.value;
        this.setState(this.state);
        this.fetchTranslation(this.state.selectedReminderId, e.target.value);
    };

    saveTranslation = () => {
        var thisController = this;
        var reminderId = thisController.state.selectedReminderId;
        var language = thisController.state.selectedLanguage;

        $.ajax({
            url: "/my-jeeva-api/translation-edit/journalreminder/" + reminderId + "?language=" + language,
            method: "PUT",
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
                'Content-Type': "application/json",
            },
            data: JSON.stringify(thisController.state.translationFields),
            success: function (res) {
                if (res.success === true) {
                    thisController.notifyTranslationSaved();
                    thisController.closeTranslationModal();
                }
            },
            error: function (xhr) {
                thisController.notifyError();
                console.error("Error saving translation");
            }
        });
    };

    notifyTranslationSaved() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Translation has been saved successfully</b>, {
            position: "top-center",
        });
    }

    render() {
        const { data } = this.state;
        const columns = [
            {
                name: <b style={{ fontSize: "16px" }}> Days of week </b>,
                width: "24vw",

                selector: (row) => (
                    <div name="name">
                        <div
                            style={{
                                display:
                                    row.id == "" ? "none" : row.id != this.state.editedId
                                        ? "block"
                                        : "none",
                            }}
                            id="appearance-for-selected-days"
                        >
                            {(row.daysOfWeek && typeof row.daysOfWeek === 'string') && JSON.parse(row.daysOfWeek).length > 0 &&
                                (JSON.parse(row.daysOfWeek)).map((selectedDay, i) => (
                                    <span key={i}>
                                        <button disabled={true}
                                            style={{ display: "inline", margin: "3px", fontSize: "12px" }}
                                            className="reminderBubble">
                                            {selectedDay}
                                        </button>
                                    </span>
                                ))}
                        </div>
                        <div
                            style={{
                                display:
                                    row.id == "" ? "block" : row.id != this.state.editedId
                                        ? "none"
                                        : "block",

                            }}
                        >
                            <Multiselect
                                options={
                                    row.id ?
                                        [
                                            ...this.state.options.filter(option => !JSON.parse(row.daysOfWeek).includes(option.value)),
                                            ...JSON.parse(row.daysOfWeek).map(day => ({
                                                label: day.slice(0, 3).charAt(0).toUpperCase() + day.slice(0, 3).slice(1).toLowerCase(),
                                                value: day.slice(0, 3).toUpperCase()
                                            }))
                                        ]
                                        : this.state.options
                                }
                                displayValue="label" // Property name to display in the dropdown options
                                selectedValues={row.id === "" ? this.state.options :
                                    JSON.parse(row.daysOfWeek).map(day => ({
                                        label: day.charAt(0).toUpperCase() + day.slice(1).toLowerCase(),
                                        value: day
                                    }))}
                                closeIcon="cancel"
                                placeholder="Select day"
                                className="multiSelectContainer"
                                onSelect={(selectedList, selectedItem) => this.handleDaysSelect(selectedList, selectedItem, row)}
                                onRemove={(selectedList, selectedItem) => this.handleDaysRemove(selectedList, selectedItem, row)}
                                disabled={row.id == "" ? false : row.id != this.state.editedId}
                            />
                        </div>
                    </div>
                ),
            },
            {
                name: <b style={{ fontSize: "16px" }}> Time </b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('timeOfDay'),
                width: "8vw",
                selector: (row) => (
                    <div>
                        <div
                            style={{
                                display:
                                    row.id == "" ? "none" : row.id != this.state.editedId
                                        ? "block"
                                        : "none",
                            }}
                            id="appearance-for-selected-days"
                        >
                            {row.timeOfDay}
                        </div>
                        <div
                            style={{
                                display:
                                    row.id == "" ? "block" : row.id != this.state.editedId
                                        ? "none"
                                        : "block",
                            }}
                        >
                            <input
                                type="time"
                                className="form-control col-11"
                                id={"reminderTime" + row.id}
                                name="time"
                                placeholder="Enter Time"
                                value={row.timeOfDay ? row.timeOfDay : this.state.reminderTime}
                                style={{
                                    width: "95%",
                                    cursor: "pointer",
                                    border: "1px solid #D2D4DC",
                                    borderRadius: "4px",
                                    border:
                                        row.id == "" || row.id == this.state.editedId
                                            ? "1px solid #D2D4DC"
                                            : "none",
                                    borderRadius: row.id == "" ? "2px" : "none",
                                }}
                                onChange={(e) => this.handleChangeTime(row, e)}
                                contentEditable={
                                    row.id === "" || row.id !== this.state.editedId ? "plaintext-only" : true
                                }

                            />
                        </div>

                    </div>
                ),
            },
            {
                name: <b style={{ fontSize: "16px" }}>Notification Title</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('title'),
                selector: (row) => (
                    <div>
                        <div
                            className="textarea"
                            style={{
                                background: "white",
                                height: "2.7em",
                                resize: "none",
                                paddingLeft: "2px",
                                paddingTop: "6px",
                                width: "100%",
                                border:
                                    row.id == "" || row.id == this.state.editedId
                                        ? "1px solid #D2D4DC"
                                        : "none",
                                borderRadius: row.id == "" ? "2px" : "none",
                                overflowY: "scroll"
                            }}
                            //   onInput={(e) => { this.handleDescriptionChange(e, row) }}
                            id={"title" + row.id}
                            contentEditable={
                                !(row.id == "" ? false : row.id != this.state.editedId)
                                    ? "plaintext-only"
                                    : false
                            }
                        >
                            {row.title}
                        </div>
                    </div>
                ),
            },

            {
                name: <b style={{ fontSize: "16px" }}>Notification Content</b>,
                width: "18vw",
                sortable: true,
                sortFunction: this.caseInsensitiveSort('content'),
                selector: (row) => (
                    <div>
                        <div
                            className="textarea"
                            style={{
                                background: "white",
                                height: "2.7em",
                                resize: "none",
                                paddingLeft: "2px",
                                paddingTop: "6px",
                                width: "100%",
                                border:
                                    row.id == "" || row.id == this.state.editedId
                                        ? "1px solid #D2D4DC"
                                        : "none",
                                borderRadius: row.id == "" ? "2px" : "none",
                                overflowY: "scroll"
                            }}
                            //   onInput={(e) => { this.handleDescriptionChange(e, row) }}
                            id={"content" + row.id}
                            contentEditable={
                                !(row.id == "" ? false : row.id != this.state.editedId)
                                    ? "plaintext-only"
                                    : false
                            }
                        >
                            {row.content}
                        </div>
                    </div>
                ),
            },
            {
                name: <b style={{ fontSize: "16px" }}>Interval Minutes</b>,
                ortable: true,
                sortFunction: this.caseInsensitiveSort('remIntervalMinutes'),
                width: "10vw",
                selector: (row) => (
                    <div>
                        <div
                            className="textarea"
                            style={{
                                background: "white",
                                height: "2.7em",
                                resize: "none",
                                paddingLeft: "2px",
                                paddingTop: "6px",
                                width: "100%",
                                border:
                                    row.id == "" || row.id == this.state.editedId
                                        ? "1px solid #D2D4DC"
                                        : "none",
                                borderRadius: row.id == "" ? "2px" : "none",
                            }}
                            id={"remIntervalMinutes" + row.id}
                            contentEditable={
                                !(row.id == "" ? false : row.id != this.state.editedId)
                                    ? "plaintext-only"
                                    : false
                            }
                        >
                            {row.remIntervalMinutes}
                        </div>
                    </div>
                ),
            },
            {
                name: <b style={{ fontSize: '16px' }}>Actions</b>,
                width: "14vw",
                selector: (props) => (
                    <div id="action">
                        <button
                            //className="btn2 table-action-button "
                            style={{
                                backgroundColor: "#ffffff", border: "none"
                            }}
                            disabled = {(this.userDetails["userRole"] === "PHYSICIAN" &&
                                this.userDetails["emailId"] !==  this.props.location.state.createdByEmail)}
                            >
                            <img className="img-responsive"
                                style={{
                                    marginTop: '8px',
                                    backgroundColor: this.userDetails["userRole"] === "PHYSICIAN" &&
                                        this.userDetails["emailId"] !==  this.props.location.state.createdByEmail
                                        ? "#282a6596"
                                        : "#282a65",
                                    borderRadius: '5px',
                                    padding: '1px'
                                }}
                                title={props.id == "" || (props.id == this.state.editedId) ? 'Save' : 'Edit'}
                                src={(props.id == "") ?
                                    this.saveImageSrc : ((props.id != this.state.editedId) ?
                                        this.editImageSrc : this.saveImageSrc)}

                                disabled={this.userDetails["userRole"] === "PHYSICIAN" &&
                                    JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy")}
                                onClick={this.userDetails["userRole"] === "PHYSICIAN" &&
                                    JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy") ? null :
                                    (e) => {
                                        (props.id == "") ?
                                            this.saveJournalReminderApi(props, e) :
                                            (props.id == this.state.editedId) ?
                                                this.updateJournalReminderApi(props, e) :
                                                this.makeCelleditable(props, e);
                                    }}
                            />
                        </button>
                        <button
                            style={{
                                backgroundColor: "#ffffff",
                                border: "none",
                                marginTop: '-9px', marginLeft: '-6px'
                            }} 
                            disabled = {(this.userDetails["userRole"] === "PHYSICIAN" &&
                                this.userDetails["emailId"] !==  this.props.location.state.createdByEmail)}
                            title="Delete">
                            <img className="img-responsive"
                                style={{
                                    marginTop: '6px',
                                    backgroundColor: (this.userDetails["userRole"] === "PHYSICIAN" &&
                                    this.userDetails["emailId"] !==  this.props.location.state.createdByEmail)
                                        ? "#282a6596"
                                        : "#282a65",
                                    borderRadius: '5px',
                                    padding: '1px'
                                }}
                                src={"./assets/images/baseline_delete_white_24dp.png"}
                                disabled={this.userDetails["userRole"] === "PHYSICIAN" &&
                                    JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy")}
                                onClick={this.userDetails["userRole"] === "PHYSICIAN" &&
                                    JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy") ? null :
                                    () => (props.id) === '' ?
                                        this.fetchJournalReminder() :
                                        this.openDeletePopUp(props)}
                            />
                        </button>
                        <button
                            style={{
                                backgroundColor: "#ffffff",
                                border: "none",
                                display: props.id == "" || props.id == this.state.editedId ? "none" : "inline"
                            }}
                            disabled={this.userDetails["userRole"] === "PHYSICIAN" &&
                                JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy")}
                            onClick={this.userDetails["userRole"] === "PHYSICIAN" &&
                                JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy") ? null :
                                (e) => {
                                    !props.id == ""
                                        ? this.handleClonedData(props)
                                        : this.makeCelledit(props, e);
                                }}
                        >
                            <img
                                className="img-responsive"
                                title="Copy"
                                style={{
                                    padding: "2px",
                                    height: "2rem",
                                    marginTop: '6px',
                                    backgroundColor: this.userDetails["userRole"] === "PHYSICIAN" &&
                                        JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy")
                                        ? "#282a6596"
                                        : "#282a65",
                                    borderRadius: '5px',
                                    padding: '1px'
                                }}
                                src={"./assets/images/copy-64.png"}
                            />
                        </button>
                        <button
                            style={{
                                backgroundColor: "#ffffff",
                                border: "none",
                                display: props.id == "" || props.id == this.state.editedId ? "none" : "inline",
                                marginTop: '-9px', marginLeft: '-6px'
                            }}
                            disabled={this.userDetails["userRole"] === "PHYSICIAN" &&
                                JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy")}
                            title="Translate"
                            onClick={this.userDetails["userRole"] === "PHYSICIAN" &&
                                JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy") ? null :
                                () => this.openTranslationModal(props)}
                        >
                            <img
                                className="img-responsive"
                                title="Translate"
                                style={{
                                    padding: "2px",
                                    height: "2rem",
                                    marginTop: '6px',
                                    backgroundColor: this.userDetails["userRole"] === "PHYSICIAN" &&
                                        JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy")
                                        ? "#282a6596"
                                        : "#282a65",
                                    borderRadius: '5px',
                                    padding: '1px'
                                }}
                                src={"./assets/images/translate_white_24dp.svg"}
                            />
                        </button>

                    </div>
                ),

            },

        ];
        return (
            <div style={{ background: "#F9F9FB", marginRight: "1%" }}>
                {/* for toaster */}
                <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                {/* for reactTable */}
                <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                {/*for dialog component */}
                <link href="assets/css/ej2-base.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                <link href="assets/css/screenResolution.css" rel="stylesheet" />
                {/* Font Awesome Icons */}
                <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                {/* IonIcons */}
                <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                {/* Select2 */}
                <link rel="stylesheet" href="plugins/select2/select2.min.css" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />
                <link rel="stylesheet" href="assets/css/buttonForm.css" />
                <link rel="stylesheet" href="./assets/css/styles.css" />
                <link rel="stylesheet" href="assets/css/adminlte.css" />
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row">
                        </div>
                        <div className="row">
                            <div className="col-sm-4" style={{ marginTop: '16px' }}  >
                                <img src="assets/images/arrow.svg"
                                    style={{ paddingRight: "30%", cursor: 'pointer' }}
                                    onClick={this.goBackFromSubTab}
                                />
                            </div>
                            <div style={{ marginLeft: "-27vw", marginTop: "0.6vh" }}>
                                <h6 className="nav-item" style={{ color: '#282a65', textAlign: 'center', marginTop: '16px' }}>
                                    Notification for  {localStorage.getItem("journalTitle")}</h6>
                            </div>
                           
                        </div>
                    </div>
                    <br/>
                    <div className="row" style={{
                        justifyContent : "flex-end",
                        marginRight : "1px"
                    }}>
                    <div
                                Align='right'
                                style={{ marginTop: "2.6vh",}}>
                                <input
                                    type="text"
                                    style={{
                                        width: "12vw",
                                        border: "2px solid #777676",
                                        borderRadius: "10px",
                                        padding: "10px",
                                        height: "0.7vw"
                                    }}
                                    value={this.state.searchTerm}
                                    onChange={this.handleSearch}
                                    placeholder="Search ..."
                                />
                            </div>
                            {/* Add button */}
                            <div Align='right' style={{ marginLeft: "10vw", marginTop: "1.5vh" }}>
                                <button className="btn action-button "
                                    title="Add"
                                    id="addMsg"
                                    disabled = {(this.userDetails["userRole"] === "PHYSICIAN" &&
                                        this.userDetails["emailId"] !==  this.props.location.state.createdByEmail)}
                                    onClick={this.state.disabled ? this.notifyMsgFieldEmpty : this.addNewReminder}
                                >
                                    <img src="assets/images/add_white_24dp.png" />
                                </button>
                                <button
                                    onClick={this.refreshData}
                                    title="Refresh"
                                    className="btn action-button">
                                    <img src="./assets/images/refresh_white_24dp.png"></img>
                                </button>
                            </div>
                    </div>
                    <div className="row" style={{ marginLeft: '15px', marginTop: '10px' }}>
                        <div className="col-lg-12 ">
                            <div className="card">
                                {this.state.isLoading && (
                                    <div style={{ padding: '20px', textAlign: 'center' }}>
                                        <p>Loading ...</p>
                                    </div>
                                )}
                                {!this.state.isLoading && this.state.data.length === 0 && !this.state.noMatchingData && (
                                    <div style={{ padding: '20px', textAlign: 'center' }}>
                                        <p>There are no journal notifications set.</p>
                                    </div>
                                )}
                                {(this.state.data.length > 0 && !this.state.noMatchingData) &&
                                    (<DataTable
                                        data={this.state.data}
                                        columns={columns}
                                        defaultPageSize={10}
                                        pageSizeOptions={[5, 10, 15]}
                                        pagination={this.state.paginationValue}
                                        onPageChange={this.onPageChange}
                                        page={this.state.pageNum}
                                        noDataComponent={<this.CustomNoDataComponent />}
                                    />)
                                }
                            </div>
                            <ToastContainer className="Toast-at-center" />
                        </div>
                    </div>
                    <div className='card'>
                        {this.state.noMatchingData &&
                            <div style={{ padding: '20px', textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
                                <p>No matching options found ...</p>
                            </div>
                        }
                    </div>

                    {/* Translation Modal */}
                    {this.state.showTranslationModal && (
                        <div
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundColor: "rgba(0, 0, 0, 0.6)",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                zIndex: 1050
                            }}
                            onClick={this.closeTranslationModal}
                        >
                            <div
                                style={{
                                    backgroundColor: "white",
                                    borderRadius: "8px",
                                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
                                    width: "500px",
                                    maxHeight: "90vh",
                                    overflow: "auto",
                                    zIndex: 1051
                                }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                {/* Modal Header */}
                                <div style={{
                                    padding: "20px 25px",
                                    borderBottom: "1px solid #e0e0e0",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                }}>
                                    <h4 style={{ margin: 0, fontSize: "18px", fontWeight: "600", color: "#282a65" }}>
                                        Translate Journal Notification
                                    </h4>
                                    <button
                                        type="button"
                                        onClick={this.closeTranslationModal}
                                        style={{
                                            background: "none",
                                            border: "none",
                                            fontSize: "24px",
                                            cursor: "pointer",
                                            color: "#666",
                                            padding: 0
                                        }}
                                    >
                                        ×
                                    </button>
                                </div>

                                {/* Modal Body */}
                                <div style={{ padding: "25px" }}>
                                    <div style={{ marginBottom: "20px" }}>
                                        <label style={{ display: "block", marginBottom: "8px", fontWeight: "600", color: "#333", fontSize: "14px" }}>Language</label>
                                        <select
                                            value={this.state.selectedLanguage}
                                            onChange={this.handleLanguageChange}
                                            style={{
                                                width: "100%",
                                                padding: "10px 12px",
                                                borderRadius: "4px",
                                                border: "1px solid #d0d0d0",
                                                fontSize: "14px",
                                                backgroundColor: "#fff",
                                                boxSizing: "border-box"
                                            }}
                                        >
                                            {this.state.translationLanguages.map((lang) => (
                                                <option key={lang.code} value={lang.code}>
                                                    {lang.displayName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {this.state.translationLoading || this.state.autoTranslating ? (
                                        <div style={{ padding: '40px 20px', textAlign: 'center' }}>
                                            <p style={{ color: "#666", fontSize: "14px", margin: 0 }}>
                                                {this.state.autoTranslating ? "🔄 Auto-translating..." : "Loading translation..."}
                                            </p>
                                        </div>
                                    ) : (
                                        <div>
                                            <div style={{ marginBottom: "20px" }}>
                                                <label style={{ display: "block", marginBottom: "8px", fontWeight: "600", color: "#333", fontSize: "14px" }}>Notification Title</label>
                                                <textarea
                                                    dir={textDirection(this.state.selectedLanguage)}
                                                    value={this.state.translationFields.title}
                                                    onChange={(e) => this.handleTranslationFieldChange('title', e.target.value)}
                                                    style={{
                                                        width: "100%",
                                                        height: "60px",
                                                        padding: "10px 12px",
                                                        borderRadius: "4px",
                                                        border: "1px solid #d0d0d0",
                                                        fontFamily: "Arial, sans-serif",
                                                        fontSize: "13px",
                                                        resize: "vertical",
                                                        boxSizing: "border-box"
                                                    }}
                                                    placeholder="Enter translation for notification title"
                                                />
                                            </div>

                                            <div style={{ marginBottom: "0" }}>
                                                <label style={{ display: "block", marginBottom: "8px", fontWeight: "600", color: "#333", fontSize: "14px" }}>Notification Content</label>
                                                <textarea
                                                    dir={textDirection(this.state.selectedLanguage)}
                                                    value={this.state.translationFields.content}
                                                    onChange={(e) => this.handleTranslationFieldChange('content', e.target.value)}
                                                    style={{
                                                        width: "100%",
                                                        height: "90px",
                                                        padding: "10px 12px",
                                                        borderRadius: "4px",
                                                        border: "1px solid #d0d0d0",
                                                        fontFamily: "Arial, sans-serif",
                                                        fontSize: "13px",
                                                        resize: "vertical",
                                                        boxSizing: "border-box"
                                                    }}
                                                    placeholder="Enter translation for notification content"
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Modal Footer */}
                                <div style={{
                                    padding: "20px 25px",
                                    borderTop: "1px solid #e0e0e0",
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    gap: "10px"
                                }}>
                                    <button
                                        type="button"
                                        onClick={this.closeTranslationModal}
                                        style={{
                                            padding: "10px 20px",
                                            backgroundColor: "#f5f5f5",
                                            border: "1px solid #d0d0d0",
                                            borderRadius: "4px",
                                            cursor: "pointer",
                                            fontSize: "14px",
                                            fontWeight: "500",
                                            color: "#333"
                                        }}
                                    >
                                        Close
                                    </button>
                                    <button
                                        type="button"
                                        onClick={this.saveTranslation}
                                        disabled={this.state.translationLoading || this.state.autoTranslating}
                                        style={{
                                            padding: "10px 24px",
                                            backgroundColor: "#282a65",
                                            color: "white",
                                            border: "none",
                                            borderRadius: "4px",
                                            cursor: this.state.translationLoading || this.state.autoTranslating ? "not-allowed" : "pointer",
                                            fontSize: "14px",
                                            fontWeight: "500",
                                            opacity: this.state.translationLoading || this.state.autoTranslating ? 0.6 : 1
                                        }}
                                    >
                                        Save Translation
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    <div
                        className="modal"
                        style={{
                            display: this.state.showModal ? "block" : "none",
                        }}
                    >
                        <div className="modal-dialog" id="center-aligned-account-modal">
                            <div
                                className="modal-content"
                                style={{ height: "450px", width: "750px" }}
                            >
                                <div className="modal-header noBorder">
                                    <div className="row">
                                        <div className="col-sm-12" align="center"></div>
                                    </div>
                                    <button
                                        type="button"
                                        className="close"
                                        data-dismiss="modal"
                                        id="close_id"
                                        onClick={() => {
                                            this.setState({
                                                showModal: false,
                                            });
                                        }}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                        >
                                            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                            <path d="M0 0h24v24H0z" fill="none" />
                                        </svg>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    {this.state.notificationPresent ?
                                        <div>
                                            <div className="row" style={{ flexDirection: "column" }}>
                                                <div className="col-sm-10" style={{ display: "flex", flexDirection: "column" }}>
                                                    <div >
                                                        <div className="box-header">Notification Title</div>
                                                        <input
                                                            type="text"
                                                            id='updateTitle'
                                                            style={{ marginTop: "0.5em", width: "29vw", padding: "1em", border: "revert", borderRadius: "7px" }}
                                                            value={this.state.notificationData.title}
                                                            onChange={(e) => this.handleTitleChange(e)}

                                                        />
                                                    </div>

                                                    <div style={{ marginTop: "1em" }}>
                                                        <div className="box-header">Notification Content</div>
                                                        <textarea
                                                            id='updateContent'
                                                            value={this.state.notificationData.content}
                                                            rows={5}
                                                            cols={30}
                                                            style={{ marginTop: "0.5em", padding: "1em", borderRadius: "7px", width: "30.8vw", resize: "none" }}
                                                            onChange={(e) => this.handleContentChange(e)}
                                                        />
                                                    </div>

                                                    <div style={{ marginTop: "1em", display: 'flex', alignItems: "center" }}>
                                                        <label>
                                                            <strong>Remind for Every</strong>
                                                        </label>
                                                        <input
                                                            type="number" min="0"
                                                            id='updateTime'
                                                            onChange={(e) => this.handleChangeRemInterval(e)}
                                                            style={{ width: "5vw", border: "revert", margin: "0em 0.5em", borderRadius: "7px", padding: "0em 0.5em" }}
                                                            // className="box-content reminder-time"
                                                            value={this.state.notificationData.remIntervalMinutes}
                                                        />
                                                        <label>
                                                            Mins
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <form>
                                            <div className="row" style={{ flexDirection: "column" }}>
                                                <div className="col-sm-10" style={{
                                                    display: "flex",
                                                    flexDirection: "column"
                                                }}>
                                                    <input
                                                        id='notificationTitle'
                                                        type='text'
                                                        placeholder='Notification Title'
                                                        style={{ width: "29vw", padding: "1em", border: "revert", borderRadius: "7px" }}
                                                        value={this.state.notificationData.title}
                                                        onChange={(e) => this.handleTitleChange(e)}
                                                    />
                                                    <textarea
                                                        id='notificationContent'
                                                        type="text"
                                                        placeholder='Notification Content'
                                                        rows={5}
                                                        cols={30}
                                                        style={{ marginTop: "1em", padding: "1em", borderRadius: "7px", width: "30.8vw", resize: "none" }}
                                                        value={this.state.notificationData.content}
                                                        onChange={(e) => this.handleContentChange(e)}
                                                    ></textarea>
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: "center",
                                                            marginTop: "1em"
                                                        }}
                                                    >
                                                        <label>
                                                            Remind for Every
                                                        </label>
                                                        <input
                                                            id='notificationRemindTime'
                                                            style={{ width: "5vw", border: "revert", margin: "0em 0.5em", borderRadius: "7px", padding: "0em 0.5em" }}
                                                            type='number' min="0"
                                                            value={this.state.notificationData.remIntervalMinutes}
                                                            onChange={(e) => this.handleChangeRemInterval(e)}
                                                        />
                                                        <label>
                                                            Mins
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    }
                                </div>
                                <button
                                    type="button"
                                    className="btn btn-primary pull-right navyblue-btn"
                                    style={{ width: "10em", fontSize: "14px", margin: "3em auto", borderRadius: "10px", marginTop: "0rem" }}
                                    onClick={() => this.state.notificationPresent ? this.updateJournalNotificationApi() : this.saveJournalNotificationApi()}                                >
                                    {this.state.notificationPresent ? "Update" : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default JournalReminder;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/JournalReminder.js